import { render, staticRenderFns } from "./SignRate.vue?vue&type=template&id=06bc5ad9&scoped=true"
import script from "./SignRate.vue?vue&type=script&lang=js"
export * from "./SignRate.vue?vue&type=script&lang=js"
import style0 from "./SignRate.vue?vue&type=style&index=0&id=06bc5ad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bc5ad9",
  null
  
)

export default component.exports